var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2506 0H15.6176L22.7007 7.38603V21.7494C22.7007 23.543 21.2437 25 19.4453 25H7.25063C5.457 25 4 23.543 4 21.7494V3.25063C3.99997 1.457 5.45697 0 7.2506 0Z",
    fill: "#0263D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6088 0V7.32835H22.7015L15.6088 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6477 13.0073H10.0551C9.75212 13.0073 9.50208 12.7621 9.50208 12.4591C9.50208 12.1562 9.75212 11.911 10.0551 11.911H16.6477C16.9506 11.911 17.1959 12.1562 17.1959 12.4591C17.1959 12.7621 16.9506 13.0073 16.6477 13.0073ZM14.4502 19.5999H10.0551C9.75212 19.5999 9.50208 19.3547 9.50208 19.0518C9.50208 18.7488 9.75212 18.5036 10.0551 18.5036H14.4502C14.7531 18.5036 14.9983 18.7488 14.9983 19.0518C14.9983 19.3547 14.7531 19.5999 14.4502 19.5999ZM16.6477 17.4024H10.0551C9.75212 17.4024 9.50208 17.1571 9.50208 16.8542C9.50208 16.5513 9.75212 16.3061 10.0551 16.3061H16.6477C16.9506 16.3061 17.1959 16.5513 17.1959 16.8542C17.1959 17.1571 16.9506 17.4024 16.6477 17.4024ZM16.6477 15.2049H10.0551C9.75212 15.2049 9.50208 14.9596 9.50208 14.6567C9.50208 14.3538 9.75212 14.1085 10.0551 14.1085H16.6477C16.9506 14.1085 17.1959 14.3538 17.1959 14.6567C17.1959 14.9596 16.9506 15.2049 16.6477 15.2049Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_24",
    x: 0,
    y: 0,
    width: 26.7015,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_24"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_24",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.8731fd80801748ef68b6dd5d7fb42e6c.svg";
export { ForwardRef as ReactComponent };